/**
 * Enhanced cart management functionality
 * - Handles cart events (add, complete, error)
 * - Manages Klaviyo analytics integration
 * - Supports URL parameter-based cart manipulation
 */

// Initialize Klaviyo analytics queue
var _learnq = window._learnq || [];

// Cart service object for centralized management
const CartService = {
  // Add item to cart with proper error handling
  addItem: function (id, quantity = 1, isVariant = true) {
    const data = {
      items: [
        {
          quantity: quantity,
          id: id,
        },
      ],
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    });
  },

  // Apply discount code to cart
  applyDiscount: function (discountCode) {
    if (!discountCode) return Promise.resolve();

    return fetch(`/discount/${discountCode}`, {
      method: 'GET',
    }).then((response) => {
      if (!response.ok) {
        throw new Error('Failed to apply discount');
      }
      console.info('Discount applied successfully');
    });
  },

  // Get current cart state
  getCart: function () {
    return fetch('/cart.js').then((response) => response.json());
  },

  // Track cart event in Klaviyo
  trackCartEvent: function (eventName, cartData) {
    _learnq.push(['track', eventName, cartData]);
  },

  // Open cart drawer with animation
  openCartDrawer: function () {
    const $drawer = $('#CartDrawer');

    $drawer.parents('.js').addClass('js-drawer-open lock-scroll');
    $drawer.addClass('is-transitioning').attr('tabindex', '-1');

    setTimeout(() => {
      $drawer.removeClass('is-transitioning').addClass('drawer--is-open');
      document.dispatchEvent(new CustomEvent('cart:build'));
      UrlUtils.removeCartParameters();
    }, 400);
  },
};

// URL utility functions
const UrlUtils = {
  // Get parameter value from URL
  getParameter: function (name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.search);
    return results === null
      ? ''
      : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },

  // Remove cart-related parameters from URL
  removeCartParameters: function () {
    const url = new URL(window.location.href);
    url.searchParams.delete('variant_id');
    url.searchParams.delete('product_id');
    url.searchParams.delete('discount_code');
    window.history.replaceState({}, document.title, url.href);
  },
};

// Initialize event listeners when DOM is ready
function initCartEvents() {
  // Track add-to-cart button clicks
  $(
    'form[action="/cart/add"] button[type="submit"], ' +
      'div.add-to-cart-now, ' +
      'input[type="submit"].add-to-cart'
  ).on('click', function () {
    // Allow time for cart to update before tracking
    setTimeout(() => {
      CartService.getCart().then((cart) => {
        CartService.trackCartEvent('Added to Cart', cart);
      });
    }, 500);
  });
}

// Handle auto-add to cart from URL parameters
function handleUrlParameterizedCart() {
  const variantId = UrlUtils.getParameter('variant_id');
  const productId = UrlUtils.getParameter('product_id');
  const discountCode = UrlUtils.getParameter('discount_code');

  let id, isVariant;

  if (variantId) {
    id = variantId;
    isVariant = true;
  } else if (productId) {
    id = productId;
    isVariant = false;
  } else {
    return; // No product specified, exit early
  }

  // Proceed with cart operations if we have a product
  if (id) {
    CartService.addItem(id, 1, isVariant)
      .then(() => CartService.applyDiscount(discountCode))
      .then(() => CartService.openCartDrawer())
      .catch((error) => console.error('Cart operation failed:', error));
  }
}

// Initialize all cart functionality
$(document).ready(function () {
  initCartEvents();
});

// Run URL parameter handling after DOM is fully loaded
document.addEventListener('DOMContentLoaded', handleUrlParameterizedCart);

// Export functions for potential external use
window.CartService = CartService;
